function AccessFeatureLockedView({ accessFeature, accessKeyInput, setAccessKeyInput, accessKeyInputError, onSubmit }) {
  return (
    <div className="row">
      <div className="col-lg-6 mb-4">
        <img
          src={accessFeature.image_1440x480}
          alt={accessFeature.title}
          className="img-fluid rounded shadow"
          style={{ aspectRatio: '3/1', objectFit: 'cover', width: '100%' }}
        />
        <div>
          <h1 className="mb-3">{accessFeature.title}</h1>
          <p className="lead text-muted">{accessFeature.description}</p>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="card shadow-sm">
          <div className="card-body">
            <h5 className="card-title mb-3">
              <i className="fas fa-lock me-2 text-warning"></i>
              Enter Access Key
            </h5>
            <p className="card-text text-muted mb-3">
              This product requires an access key. Please enter your key below to unlock the content.
            </p>
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <input
                  type="text"
                  className={`form-control ${accessKeyInputError ? 'is-invalid' : ''}`}
                  placeholder="Enter your access key"
                  value={accessKeyInput}
                  onChange={(e) => setAccessKeyInput(e.target.value)}
                  required
                />
                {accessKeyInputError && <div className="invalid-feedback">{accessKeyInputError}</div>}
              </div>
              <button type="submit" className="btn btn-primary w-100">
                <i className="fas fa-unlock me-2"></i>
                Unlock Product
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccessFeatureLockedView;